export const messages = {
  en: {
    staffCommunity: {
      orgPlaceholder: 'Select organization',
      staffNamePlaceholder: 'Enter staff name',
      linkCommunity: 'Link Community',
      staffName: 'Staff Name',
      staffId: 'Staff ID',
      communityId: 'Community ID',
      communityName: 'Community Name',
      operation: 'Operation',
      chooseOrgTitle: 'Select Organization',
      fetchOrgError: 'Failed to load organization data',
      selectOrgTip: 'Please select an organization',
      addCommunityTitle: 'Add Community',
      communityNamePlaceholder: 'Enter community name',
      communityAddress: 'Community Address',
      fetchCommunityError: 'Failed to load community data',
      selectCommunityTip: 'Please select at least one community',
      addSuccess: 'Added successfully',
      addError: 'Failed to add',
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirmText: 'Are you sure to delete this community association?',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete',
      fetchStaffError: 'Failed to load staff data'
    }
  },
  zh: {
    staffCommunity: {
      orgPlaceholder: '选择组织',
      staffNamePlaceholder: '输入员工名称',
      linkCommunity: '关联小区',
      staffName: '员工名称',
      staffId: '员工编号',
      communityId: '小区编号',
      communityName: '小区名称',
      operation: '操作',
      chooseOrgTitle: '选择组织',
      fetchOrgError: '加载组织数据失败',
      selectOrgTip: '请选择组织',
      addCommunityTitle: '添加小区',
      communityNamePlaceholder: '输入小区名称',
      communityAddress: '小区地址',
      fetchCommunityError: '加载小区数据失败',
      selectCommunityTip: '请至少选择一个小',
      addSuccess: '添加成功',
      addError: '添加失败',
      deleteConfirmTitle: '确认删除',
      deleteConfirmText: '确定删除该小区关联吗？',
      deleteSuccess: '删除成功',
      deleteError: '删除失败',
      fetchStaffError: '加载员工数据失败'
    }
  }
}